import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService } from './../../../core/services/base.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-sales-order-line-dialog',
  templateUrl: './sales-order-line-dialog.component.html',
  styleUrls: ['./sales-order-line-dialog.component.scss']
})
export class SalesOrderLineDialogComponent implements OnInit {
  warehouses: {
    availableStock: number;
    deliveryMethods: {
      deliveryMethodDesc: string;
      deliveryMethodId: number;
    }[];
    warehouseCode: string;
    warehouseDesc: string;
  }[] = [];

  warehouse: {
    availableStock: number;
    deliveryMethods: {
      deliveryMethodDesc: string;
      deliveryMethodId: number;
    }[];
    warehouseCode: string;
    warehouseDesc: string;
  };

  deliveryMethods: {
    deliveryMethodDesc: string;
    deliveryMethodId: number;
  }[] = [];

  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SalesOrderLineDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null, Validators.compose([Validators.required])],
      lineNumber: [null, Validators.compose([Validators.required])],
      stockCode: [null, Validators.compose([Validators.required])],
      lineDescription: [null, Validators.compose([Validators.required])],
      lineDescription2: [null, Validators.compose([Validators.required])],
      orderQty: [null, Validators.compose([Validators.required, Validators.min(1)])],
      availableQty: [0],
      warehouseCode: [null, Validators.compose([Validators.required])],
      deliveryMethodId: [null, Validators.compose([Validators.required])],
      partCategory: [null, Validators.compose([Validators.required])],
      leadTime: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.form.patchValue(this.data);

    this.form.controls['lineNumber'].disable();
    this.form.controls['stockCode'].disable();
    this.form.controls['lineDescription'].disable();
    this.form.controls['lineDescription2'].disable();
    this.form.controls['availableQty'].disable();
    this.form.controls['partCategory'].disable();
    this.form.controls['leadTime'].disable();

    this.baseService.executeCommand<any[]>('portal_sales_order_line_dialog_config', {
      salesOrderHeaderId: this.data.salesOrderHeaderId,
      lineNumber: this.data.lineNumber
    }).subscribe(response => {
      if (response.responseCode === 0) {
        this.warehouses = response.data || [];
        this.warehouse = this.warehouses.find(f => f.warehouseCode === this.form.value.warehouseCode);
        if (this.warehouse) {
          this.deliveryMethods = this.warehouse.deliveryMethods || [];
          this.form.controls['availableQty'].setValue(this.warehouse.availableStock);
        }
      }
    });
  }

  save() {
    this.baseService.executeCommand<any[]>('portal_sales_order_line_warehouse_qty_modify', {
      salesOrderHeaderId: this.data.salesOrderHeaderId,
      lineNumber: this.form.getRawValue().lineNumber,
      qty: this.form.value.orderQty,
      warehouseCode: this.form.value.warehouseCode,
      deliveryMethodId: this.form.value.deliveryMethodId
    })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }

  warehouseChanged(event: MatSelectChange) {
    this.warehouse = this.warehouses.find(f => f.warehouseCode === this.form.value.warehouseCode);
    this.form.controls['deliveryMethodId'].reset();
    this.form.controls['availableQty'].reset();

    if (this.warehouse) {
      this.deliveryMethods = this.warehouse.deliveryMethods || [];
      this.form.controls['availableQty'].setValue(this.warehouse.availableStock);
    }
  }

}
